/**
 * Auction enums - numeric values mirror the future Marketplace.API contract
 * (HLD §9, §17 `Auction` / `Bid`).
 */

/** Auction lifecycle (HLD §9.1 state machine). */
export enum AuctionStatus {
  Scheduled = 1,
  Live = 2,
  Closing = 3,
  Closed = 4,
  Cancelled = 5
}

export const AuctionStatusLabel: Record<AuctionStatus, string> = {
  [AuctionStatus.Scheduled]: 'Scheduled',
  [AuctionStatus.Live]: 'Live',
  [AuctionStatus.Closing]: 'Closing',
  [AuctionStatus.Closed]: 'Closed',
  [AuctionStatus.Cancelled]: 'Cancelled'
};

/** How a settled auction ended (HLD §9.3–§9.4, §17 `AuctionResult`). */
export enum AuctionOutcome {
  Won = 1,
  ReserveNotMet = 2,
  NoBids = 3
}

export const AuctionOutcomeLabel: Record<AuctionOutcome, string> = {
  [AuctionOutcome.Won]: 'Won',
  [AuctionOutcome.ReserveNotMet]: 'Reserve Not Met',
  [AuctionOutcome.NoBids]: 'No Bids'
};

/** Bid state - bids are append-only; status marks the current standing. */
export enum BidStatus {
  Active = 1,
  Outbid = 2,
  Retracted = 3
}

export const BidStatusLabel: Record<BidStatus, string> = {
  [BidStatus.Active]: 'Active',
  [BidStatus.Outbid]: 'Outbid',
  [BidStatus.Retracted]: 'Retracted'
};
